export const API_URL = {

  // Auth
  LOGIN: '/admin/login',
  LOGOUT: '/admin/logout',
  ME_URL: "/admin",
  REGISTER: "/admin",
  EDIT_MY_INFO: '/admin',
  CHANGE_PW: '/admin/change-pwd',
  CHECK_ID: '/admin/check-dup-id',
  FIND_ID: '/admin/find-id',
  CHECK_BUSINESS_NO: '/admin/validate-corp-num',
  CHECK_BANK_ACCOUNT: '/admin/validate-bank-account',
  SEND_CERT_NUM: '/admin/generate-tel-cert-num',
  VALID_CERT_NUM: '/admin/validate-tel-cert-num',

  // Balances
  BALANCE_SUMMARY: "/balances/summary",
  BALANCE_SALES_LIST: "/balances/sales",
  BALANCE_EXCEL_DOWNLOAD: "/balances/download",

  // Categories
  CATEGORY_LIST: "/category",
  CATEGORY_UPDATE: "/category",

  // Links
  LINK_LIST: "/sale",
  LINK_DETAIL: /\/sale\/(\w+)/,
  LINK_GOODS: "/sale/goods",
  LINK: /\/sale\/goods\/(\w+)/,
  LINK_SELLERS: "/sale/goods/sellers",
  LINK_CREATE: "/goods/sale-list",

  // Orders
  ORDER_LIST: "/order",
  ORDER_UPDATE: "/order",
  ORDER: /\/order\/(\w+)/,

  // Products
  PRODUCT_LIST: '/goods',
  PRODUCT: /^\/goods\/(\w+)/,

  // Samples
  SAMPLE_LIST: "/req-samples/",
  SAMPLE: /\/req-samples\/(\w+)/,

  // QNA
  QNA_LIST: "/cs",
  QNA: /\/cs\/(\d+)/,
  REPLY_TO_QNA: "/cs",

  // Partners
  PROVIDER_LIST: "api/providers",
  PROVIDER: /api\/providers\/(\d+)/,

  // Sellers
  SELLER_LIST: "api/sellers",
  SELLER: /api\/sellers\/(\d+)/,

  // Customers
  CUSTOMER_LIST: "api/customers",
  CUSTOMER: /api\/customers\/(\d+)/,

  // Categories
  CATEGORY: /api\/categories\/(\d+)/,
};
